import React, { useState, useEffect } from 'react'
import { Nav } from 'rsuite'
import { H1 } from '../Components/Event/EventStyledComponents'
import styled from 'styled-components'
import Profile from '../Components/Settings/Profile'
import Password from '../Components/Settings/Password'
import Payment from '../Components/Settings/Payment'
import Subscription from './SubscriptionPlan'

const CustomNav = styled(Nav)`
.rs-nav-subtle, .rs-nav-horizontal, .rs-nav-item > .rs-nav-item-content {
  font-size: 20px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  margin-right: 68px;
},

.rs-nav > ul {
  margin-left: 39px;
}
`
const Navigation = ({ active, onSelect, ...props }) => {
  return (
    <CustomNav {...props} activeKey={active} onSelect={onSelect}>
      <Nav.Item eventKey='profile'>Profile</Nav.Item>
      <Nav.Item eventKey='password'>Password</Nav.Item>
      <Nav.Item eventKey='subscription-plan'>Subscription plan</Nav.Item>
      <Nav.Item eventKey='payment'>Payment</Nav.Item>
    </CustomNav>
  )
}

const Settings = props => {
  const [activeTab, setActiveTab] = useState(props.location.active || 'profile')
  const handleSelect = activeKey => setActiveTab(activeKey)

  const queryParams = new URLSearchParams(window.location.search)
  const tab = queryParams.get('active')
  useEffect(() => {
    if (tab !== null) {
      setActiveTab(tab)
    }
  }, [])

  return (
    <div>
      <H1 style={{ margin: '28px 49px' }}>Settings</H1>
      <Navigation appearance='subtle' active={activeTab} onSelect={e => handleSelect(e)} />
      {activeTab === 'profile' && <Profile />}
      {activeTab === 'password' && <Password />}
      {activeTab === 'subscription-plan' && <Subscription />}
      {activeTab === 'payment' && <Payment />}
    </div>
  )
}

export default Settings
